import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { SvgIcon } from '@mui/material';
import MuiStepIcon from '@mui/material/StepIcon';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
import { CheckmarkIcon } from '../../icons';
export var styles = function (theme) { return ({
    root: {
        width: 30,
        height: 30,
        fill: 'transparent',
        transition: 'fill 0.2s',
        '&& circle': {
            strokeWidth: 1,
            transition: theme.transitions.create('stroke'),
            stroke: theme.palette.grey[200],
        },
    },
    active: {
        '&& circle': {
            stroke: theme.palette.success.main,
        },
    },
    completed: {
        stroke: theme.palette.common.white,
        fill: theme.palette.success.main,
        '&& path': {
            fill: theme.palette.common.white,
        },
        '&& circle': {
            stroke: theme.palette.success.main,
        },
    },
    error: {},
    text: {
        fontSize: theme.typography.pxToRem(12),
        fill: theme.palette.text.primary,
    },
}); };
/**
 * @public
 */
var StepIcon = forwardRef(function (_a, ref) {
    var classes = _a.classes, active = _a.active, completed = _a.completed, error = _a.error, className = _a.className, icon = _a.icon, children = _a.children, props = __rest(_a, ["classes", "active", "completed", "error", "className", "icon", "children"]);
    return (React.createElement(SvgIcon, __assign({ className: clsx(classes === null || classes === void 0 ? void 0 : classes.root, active && (classes === null || classes === void 0 ? void 0 : classes.active), error && (classes === null || classes === void 0 ? void 0 : classes.error), completed && (classes === null || classes === void 0 ? void 0 : classes.completed), className), ref: ref }, props),
        React.createElement("circle", { cx: "12", cy: "12", r: "11" }),
        completed ? (React.createElement(CheckmarkIcon, { x: 3, y: 3, width: "80%", height: "80%" })) : (icon && (React.createElement("text", { className: classes === null || classes === void 0 ? void 0 : classes.text, textAnchor: "middle", x: "12px", y: "16px" }, icon))),
        children));
});
// @ts-expect-error https://material-ui.com/guides/composition/#wrapping-components
StepIcon.muiName = MuiStepIcon.muiName;
export default withStyles(styles, { name: 'BwStepIcon' })(StepIcon);
/** @private @internal for docs only! */
export var DocsStepIcon = function (props) { return React.createElement(StepIcon, __assign({}, props)); };
//# sourceMappingURL=StepIcon.js.map